module.exports = __webpack_public_path__ + "media/images/icons/remove-icon-963d2e2388cabe7de62c98f84b279a84.svg";